import z from "zod";

/**
 * ReportLogAcessoSistemaColumnsSchema
 */

export const ReportLogAcessoSistemaSchema = z.object({
    requiredMimeType: z.string().optional().nullable(),
    idUsuario: z.coerce.number().nonnegative(),
    dataDe: z.coerce.date().optional().nullable().default(null),
    dataAte: z.coerce.date().optional().nullable().default(null),


});

/**
 * ReportLogAcessoSistemaForm
 */

export type ReportLogAcessoSistemaForm = z.infer<typeof ReportLogAcessoSistemaSchema>;

export const defaultReportLogAcessoSistemaForm: ReportLogAcessoSistemaForm = {
    idUsuario: 0,
    dataDe: null,
    dataAte: null,
    requiredMimeType: null,

};


